// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__2GspT","userActivationAlert":"Alert_userActivationAlert__1d5T9"};